import { getOrganizationSchema } from './organization';

export function getPersonSchema({ name, jobTitle, pathname, photoUrl }) {
  return {
    '@type': 'Person',
    name,
    jobTitle,
    image: photoUrl,
    url: `https://www.edmunds.com${pathname}`,
    worksFor: getOrganizationSchema(),
  };
}

export function getPersonSimpleSchema(name) {
  if (!name) {
    return undefined;
  }

  return {
    '@type': 'Person',
    name,
  };
}
